import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../../images/collapse copy 5.png'
import ExpandIcon from '../../../../images/expand copy 5.png'

class TinglystDokumentBestilling extends Component {
    state = {
        isOpened: false
    }

    toggleBestilling = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var bestilling = this.props.bestilling

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleBestilling}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{t('tinglystdokument')} {bestilling.dokumentaar}/{bestilling.dokumentnummer}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('gdobrukernavn')}</div>
                            <div className="value">{bestilling.gdoUsername}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bestillingsdato')}</div>
                            <div className="value"><Moment local parse="YYYY-MM-DDTHH:mm:ss">{bestilling.bestillingsDato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('dokumentaar')}</div>
                            <div className="value">{bestilling.dokumentaar}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('dokumentnummer')}</div>
                            <div className="value">{bestilling.dokumentnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('embete')}</div>
                            <div className="value">{bestilling.embetenummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('fakturareferanse')}</div>
                            <div className="value">{bestilling.fakturareferanse}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(TinglystDokumentBestilling)